import { api } from "../../api/apiSlice";

// Read-only slice, dashboard-only for now - the Collections module itself
// (create/edit/list screens) is Flutter-only as of this build, per
// CollectionsController.cs's own doc comment ("Field-collector Credit/Cheque
// Collections"). /collections/summary covers every simple KPI/chart widget
// (its `groupBy` param already handles branch/day/month/customer). The
// Collections Dashboard Section (ported from Flutter, 2026-09-02) needs the
// flat record list too - for its per-branch Employee/Type/Payment-method
// breakdown and its Post-Dated-Cheques/Cheques-Due-Today figures, the same
// reason Flutter's own dashboard pages this same endpoint client-side
// rather than a server-side groupBy that doesn't exist for those dimensions.
export const collectionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCollectionsSummary: builder.query({
      query: (params) => ({ url: "/collections/summary", params }),
    }),
    getCollectionsListPage: builder.query({
      query: (params) => ({ url: "/collections", params }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetCollectionsSummaryQuery,
  useLazyGetCollectionsSummaryQuery,
  useGetCollectionsListPageQuery,
  useLazyGetCollectionsListPageQuery,
} = collectionsApi;
